import { PledgePotStore } from '@stores/pledge-pot.store';
import apiResponse from '@stores/ApiResponse';
import { useQuery } from '@tanstack/react-query';
import { Duration } from 'luxon';

export type PledgePotView = {
  potAmount: number;
};

export class PledgePotViewCreator {
  constructor(private readonly store: PledgePotStore = new PledgePotStore()) {}

  async createView(groupId: number) {
    const result = await apiResponse.handleApiResponse<{
      potAmount: number;
    }>(async () => await new PledgePotStore().getPledgePot(groupId));

    return {
      potAmount: result.potAmount,
    } as PledgePotView;
  }
}

export const usePledgePotViewCreator = (groupId: number) =>
  useQuery({
    queryKey: [PledgePotViewCreator.name, groupId],
    queryFn: () => new PledgePotViewCreator().createView(groupId),
    staleTime: Duration.fromObject({ minutes: 1 }).milliseconds,
  });
